<template>
  <div :style="'background:' + colors.beijing" class="w-100 h-100 scrollY">
    <div class="padding">
      <div v-if="lang == 'han'">
        <div
          class="back "
          @click="goBack"
          :style="'background:' + colors.beijing"
        >
          <div class="flex-row pd">
            <div class="flex-1">&lt;</div>
            <div>移动端应用声明</div>
            <div class="flex-1"></div>
          </div>
        </div>
        <p align="center" class="content"><strong></strong></p>
        <p>&nbsp;</p>
        <p><strong>1. 数据安全</strong></p>
        <p>
          所有用户输入的临床/影像学特征（如
          TB、INR、Na、PLT、2D-SWE）以及生成的预后预测结果均在设备本地处理。不向任何外部服务器、云平台或第三方传输数据，从而避免传输过程中可能发生的数据泄露风险。
        </p>
        <p>&nbsp;</p>
        <p><strong>2. 隐私保护</strong></p>
        <p>
          应用仅需要去标识化的特征用于预测——不会收集或存储任何可识别个人身份的信息，例如患者姓名、证件号码、病历号或联系方式。此设计可确保完全符合患者隐私保护相关法规。
        </p>
        <p>&nbsp;</p>
        <p><strong>3. 预期用途</strong></p>
        <p>
          本应用是一款临床决策支持工具，而非专业医疗判断的替代品。其用于预测急性加重期慢性肝衰竭（ACLF）患者的
          30 天、90 天及 1 年预后（恶化风险）。
        </p>
        <p>&nbsp;</p>
        <p><strong>4. 人因/可用性测试</strong></p>
        <p>
          我们与 10 名临床医生（5 名肝病科医师和 5
          名胃肠科医师）进行了可用性测试，以优化应用与临床工作流程的契合度。测试在模拟临床环境中进行，所有测试者均成功完成预后预测任务，平均用时为每名患者
          8.7 ± 1.2 秒。根据 5
          分制李克特量表评估，应用界面被所有参与者评价为“直观”（平均得分：4.6 ±
          0.5）和“临床兼容性高”（平均得分：4.5 ± 0.6）。
        </p>
        <p>&nbsp;</p>
        <p><strong>5. 阈值再校准</strong></p>
        <p>
          为支持新中心的阈值再校准，本应用对应的模型已在 GitHub 上公开：<a
            href="https://github.com/binhuang15/ACLFapp"
            target="blank"
            >https://github.com/binhuang15/ACLFapp</a
          >。仓库中包含预训练模型、易于使用的执行脚本和示例数据，便于使用本地验证数据进行再校准。
        </p>
      </div>
      <div v-if="lang == 'ying'">
        <div
          class="back "
          @click="goBack"
          :style="'background:' + colors.beijing"
        >
          <div class="flex-row pd">
            <div class="flex-1">&lt;</div>
            <div>STATEMENTS ON THE MOBILE APP</div>
            <div class="flex-1"></div>
          </div>
        </div>
        <p align="center" class="content">
          <strong></strong>
        </p>

        <p>&nbsp;</p>

        <p><strong>1. Data Security</strong></p>

        <p>
          All user-input clinical/imaging features (e.g., TB, INR, Na, PLT,
          2D-SWE) and generated prognostic predictions are processed locally on
          the device. No data is transmitted to external servers, cloud
          platforms, or third parties, eliminating risks of data breaches during
          transmission.
        </p>

        <p>&nbsp;</p>

        <p><strong>2. Privacy Protection</strong></p>

        <p>
          The app only requires de-identified features for prediction&mdash;no
          personally identifiable information such as patient name, ID number,
          medical record number, or contact details is collected or stored. This
          ensures full compliance with patient privacy regulations.
        </p>

        <p>&nbsp;</p>

        <p><strong>3. Intended Use</strong></p>

        <p>
          The app is a clinical decision support tool, not a substitute for
          professional medical judgment. It is intended for prognostic
          predictions of 30-day, 90-day, and 1-year outcomes (deterioration
          risk) for acute-on-chronic liver failure (ACLF) patients.
        </p>

        <p>&nbsp;</p>

        <p><strong>4. Human-Factors/Usability Testing</strong></p>

        <p>
          We conducted usability testing with 10 practicing clinicians (5
          hepatologists and 5 gastroenterologists) to optimize the app&rsquo;s
          alignment with clinical workflows. Testing was performed in a
          simulated clinical environment, and all testers successfully completed
          prognostic prediction tasks with an average time of 8.7 &plusmn; 1.2
          seconds per patient. Based on a 5-point Likert scale evaluation, the
          app&rsquo;s interface was rated &quot;intuitive&quot; (mean score: 4.6
          &plusmn; 0.5) and &quot;clinically compatible&quot; (mean score: 4.5
          &plusmn; 0.6) by all participants.
        </p>

        <p>&nbsp;</p>

        <p><strong>5. Threshold Re-calibration</strong></p>

        <p>
          To support threshold-recalibration for new sites, the model
          corresponding to the app is publicly available at
          <a href="https://github.com/binhuang15/ACLFapp" target="blank"
            >https://github.com/binhuang15/ACLFapp</a
          >. The repository includes pre-trained models, a user-friendly
          execution script, and example data, enabling convenient recalibration
          with local validation data.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Config from "../Config";
import { PageHelper } from "../PageHelper";
import { HttpHelper } from "../HttpHelper";
export default {
  created() {
    PageHelper.Init(this);
    HttpHelper.Post("calculate/colordetail", {}).then(ret => {
      this.colors = ret;
    });
  },
  methods: {
    goBack() {
      this.$router.push("/");
    }
  },
  data() {
    return {
      Res: {},
      colors: "",
      lang: this.$route.params.lang
    };
  }
};
</script>
<style scoped>
.back {
  position: fixed; /* 固定顶部 */
  top: 0;
  left: 0;
  width: 100%;
  line-height: 50px; /* 垂直居中 */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* 底部阴影 */
  font-weight: bold;
  z-index: 1000; /* 保证覆盖内容 */
  cursor: pointer;
}
.pd{
    
  margin: 20px;
}

.content {
  margin-top: 50px; /* 留出顶部空间避免内容被覆盖 */
}
</style>



// WEBPACK FOOTER //
// src/components/statement.vue